<template>
  <div>
    <button class="headerInfoDownload headerInfoButton" data-bs-toggle="modal" data-bs-target="#donwload_overlay">
      資料ダウンロード
    </button>
    <download-pamphlet-modal
      v-show="isPamphletModalVisible"
      @hideModal="hideDownloadPamphletModal"/>
  </div>

</template>

<script>
  import DownloadPamphletModal from '@/pages/search/top/download_pamphlet_modal'
  import { mapGetters } from 'vuex'
  export default {
    components: { DownloadPamphletModal },
    mounted() {
      this.$store.commit('map/setSelectedMarkerId', $('#selectedCareHomeId').data('id'))
    },
    computed: {
      ...mapGetters('map', ['mapSelectedMarkerId']),
    },
    data() {
      return {
        isPamphletModalVisible: false,
      }
    },
    methods: {
      showDownloadPamphletModal() {
        this.isPamphletModalVisible = true
      },
      hideDownloadPamphletModal(){
        this.isPamphletModalVisible = false
      },
    }
  }
</script>
